var link_viewer_default = {
  "fontElementMap": "wigmf",
  "link": "IMX5w",
  "linkInEditor": "w-O2I",
  "linkInViewer": "ra8vj",
  "toolbarUrlContainer": "Mc6b9",
  "toolbarUrl": "NNvur",
  "toolbarUrlAnchor": "SXL6Y"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
